module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Chair2-33c82d6609ed43b36b485514b87ffddf.svg";